const commonFn = {};

//学段下拉
commonFn.getPeriodList = function (e, postData) {
    var that = e;

    var url = that.globalAPI.mainApi + 'stu/login/getPeriodList';

    var postData = {
        data: postData,
    };

    postData = that.qs.parse(postData);

    that.axios
        .post(url, postData)
        .then(function (response) {
            if (response.data.code == 1) {
                that.periodList = response.data.data;
            } else {
                that.$toast.fail(response.data.msg);
            }
        })
        .catch(function (error) {
            console.log(error);
        });
};

//课程下拉
commonFn.getPeriodKcList = function (e) {
    var that = e;

    var url = that.globalAPI.mainApi + 'stu/login/getPeriodKcList';

    var postData = {
        data: {
            userId: that.userInfoSession.userId,
            merchantId: that.userInfoSession.merchantId,
            typeId: that.userInfoSession.typeId,
            isShow: 'official',
        },
    };

    postData = that.qs.parse(postData);

    that.axios
        .post(url, postData)
        .then(function (response) {
            if (response.data.code == 1) {
                that.periodKcList = response.data.data;
            } else {
                that.$toast.fail(response.data.msg);
            }
        })
        .catch(function (error) {
            console.log(error);
        });
};

//返回当前时间
commonFn.getNowDate = function (date) {
    var currentDate = new Date(date);
    var year = currentDate.getFullYear();
    var month = (currentDate.getMonth() + 1).toString().padStart(2, '0');
    var day = currentDate.getDate().toString().padStart(2, '0');
    var hours = currentDate.getHours().toString().padStart(2, '0');
    var minutes = currentDate.getMinutes().toString().padStart(2, '0');
    var seconds = currentDate.getSeconds().toString().padStart(2, '0');
    var formattedDateTime = year + '-' + month + '-' + day + ' ' + hours + ':' + minutes + ':' + seconds;
    return formattedDateTime;
};

//返回当前日期+N天
commonFn.getAssignDay = function (assignDay, day) {
    var today = new Date(assignDay);
    var targetday_milliseconds = today.getTime() + 1000 * 60 * 60 * 24 * day;
    today.setTime(targetday_milliseconds);
    var tYear = today.getFullYear();
    var tMonth = today.getMonth() + 1;
    var tDate = today.getDate();
    if (tMonth.toString().length == 1) {
        tMonth = "0" + tMonth;
    }
    if (tDate.toString().length == 1) {
        tDate = "0" + tDate;
    }
    return tYear + "-" + tMonth + "-" + tDate;
};

//返回当前日期+N月
commonFn.getAssignMonth = function (assignMonth, month) {
    var currentMonth = new Date(assignMonth);
    currentMonth.setMonth(currentMonth.getMonth() + month);
    var tYear = currentMonth.getFullYear();
    var tMonth = currentMonth.getMonth() + 1;
    if (tMonth.toString().length == 1) {
        tMonth = "0" + tMonth;
    }
    return tYear + "-" + tMonth;
};

//Vant图片预览
commonFn.imgPreview = function (e, images, startPosition) {
    var that = e;
    that.ImagePreview({
        images: images,
        startPosition: startPosition,
    });
}

//文件上传
commonFn.uploadFile = function (e, file, postData, type) {
    //登录请求
    var that = e;
    //请求地址
    var url = that.globalAPI.uploadApi;

    const formData = new FormData();
    formData.append('file', file)
    formData.append('filePath', postData)

    that.axios
        .post(url, formData)
        .then(function (response) {
            if (response.data.code == 1) {
                if (type == 1) {
                    that.updateStuLogin({
                        userId: that.userInfoSession.userId,
                        stuImg: response.data.data,
                    });
                }
            } else {
                that.$toast.fail(response.data.msg);
            }
        })
        .catch(function (error) {
            console.log(error);
        });
};

module.exports = commonFn;


// WEBPACK FOOTER //
// ./src/plugin/commonFn.js